/**
 * 缓存说明:单位缓存
 */
import vm from '@/cache/storeTools.js'
import unitApi from '@/components/api/unitApi.js'
import deviceApi from '@/components/api/deviceApi.js'
import deviceStore from './deviceStore.js'
import archivesStore from '@/cache/archivesStore.js'
import {areaFindArea} from '../api/energySubArea'



var basestate = {
	unitTree: {
		//当前用户所可以查看的完整单位树
	},
	areaTree:{},//当前用户区域树
	nowArea:{
		//当前选中的区域
	},
	unitIdToInfo: {
		//单位id和信息键值对
	},
	nowUnit: {
		//当前选中的单位
	},
	unitGroupNo: {
		//当前单位组No
	},
	unitList: { // 含 level的 unit列表

	},
	unitDefects: {
		//单位缺陷
	},
	unitIdToLoadDeviceList: {
		//单位的负荷设备配置
	},
	unitIdToLoadCount: {
		//单位的对应负荷容量
	},
	industry:undefined,//所有的行业信息
	buildingNum:true, //建筑信息页面添加删除操作就更新头部菜单

}
//添加 level 等级
function treeToList(data, aimList, level) {
	if (data instanceof Array) {
		for (let item of data) {
			item.level = level
			aimList.push(item)
			if (item.next instanceof Array) {
				treeToList(item.next, aimList, level + 1)
			}
		}
	} else {
		if (!isempty(data)) {
			data.level = level
			aimList.push(data)
			if (data.next instanceof Array) {
				treeToList(data.next, aimList, level + 1)
			}
		}
	}
}
var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		/**
		 * 获取该单位下的缺陷信息
		 */
		getUnitDefectById(state, getters) {
			return (id) => {
				if (isempty(state.unitDefects[id])) {
					// store.commit("getUnitDefectById",id)
					return {}
				}
				return state.unitDefects[id]
			}

		},
		/**
		 * 获取当前用户可查看单位树
		 */
		getUnitTree(state, getters) {
			if (isempty(state.unitTree)) {
				store.commit("getUnitTree")
			}
			return state.unitTree
		},
		/**
		 * 获取当前用户的区域树形
		 */
		 getAreaTree(state, getters) {
			if (isempty(state.areaTree)) {
				store.commit("getAreaTree")
			}
			return state.areaTree
		},
		
		/**
		 * 获取单位含level 的单位list
		 */
		getUnitList(state, getters) {
			if (isempty(state.unitList)) {
				store.commit("getUnitList")
			}
			if (state.unitList instanceof Array) {
				return state.unitList
			}
		},
		/**
		 * 当前选中单位
		 */
		getNowUnit(state, getters) {
			if (isempty(state.nowUnit)) {
				//默认是最上级
				state.nowUnit = state.unitTree
			}
			return state.nowUnit
		},
		getUnitGroupNo(state, getters) {
			if (isempty(state.unitGroupNo)) {
				store.commit("setUnitGroupNo", state.nowUnit.id)
			}
			return state.unitGroupNo
		},
		getLoadDeviceList(state, getters) {
			return unitId => {
				return vm.getBeanById(store, state.unitIdToLoadDeviceList, 'getLoadDeviceList', [])(unitId)
			}
		},
		getLoadCount(state, getters) {
			return unitId => {
				var loadDeviceList = getters.getLoadDeviceList(unitId)
				var infoList = archivesStore.getters.getArchivesByDeviceNos(loadDeviceList.map(item=>item.deviceno))
				var count = 0
				for (var i = 0, len = loadDeviceList.length; i < len; i++) {
					var item = loadDeviceList[i]
					var info = infoList[i]
					if (!isempty(info) && !isempty(info.next)) {
						var target = info.next.find(it => it.propertyCode == "Capacity")
						if (!isempty(target) && !isempty(target.value)) {
							try {
								count += parseFloat(target.value)
							} catch (e) {}
						}
					}
				}
				return parseInt(count)
			}
		},
		getIndustry(state, getters){
			if(state.industry==undefined){
				store.commit("getIndustry")
			}else{
				return state.industry
			}
		}
	},
	mutations: {
		setBuildingNum(state,type){
			vm.Vue.set(state, "buildingNum", type)
		},
		cleanUnitDefects(state) {
			vm.Vue.set(state, 'unitDefects', {})
		},
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		
		//根据ID获取单位缺陷的信息
		setUnitDefectById(state, data) {
			vm.Vue.set(state.unitDefects, data.id, data)
		},
		getUnitList(state, data) {
			unitApi.getUnitTree(respon => {
				let reslist = [];
				treeToList(respon, reslist, 1)
				vm.Vue.set(state, 'unitList', reslist)
			})
		},
		getUnitTree(state) {
			unitApi.getUnitTree(respon => {
				state.unitTree = respon
				if (isempty(state.nowUnit)) {
					state.nowUnit = respon
				}
			})
			
		},
		getAreaTree(state) {
			areaFindArea().then(res => {

				if(res.code == 200){
					state.areaTree = res.data
				}
			})
			
			
		},
		
		
		/**
		 * 设置当前选中单位
		 */
		setNowUnit(state, unitId) {
			function findUnit(tree, unitId) {
				if (tree == undefined) {
					return
				}
				if (tree.id == unitId) {
					return tree
				}
				var next = tree.next
				if (!isempty(next)) {
					for (var i = 0, len = next.length; i < len; i++) {
						var unit = findUnit(next[i], unitId)
						if (unit != undefined) {
							return unit
						}
					}
				}
			}
			//通过unitId在缓存中寻找对象，避免传过来的数据结构有问题
			var unit = findUnit(state.unitTree, unitId)
			if (unit != undefined) {
				state.nowUnit = unit
			}
		},
		setUnitGroupNo(state, unitId) {},
		getLoadDeviceList(state, unitId) {
			deviceApi.getDeviceListByDeviceType(unitId, 'load', respon => {
				vm.Vue.set(state.unitIdToLoadDeviceList, unitId, respon)
			})
		},
		getIndustry(state,getters){
			unitApi.getAllIndustry(respon=>{
				vm.Vue.set(state,'industry',respon)
			})
		}
	}
});

//对外提供
export default store
